import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import CouponReader from '@tekion/tekion-base/readers/Coupon';
var getCouponOptionLabel = function getCouponOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var data = option.data;
  return CouponReader.name(data);
};
var getCouponOptionValue = function getCouponOptionValue() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var data = option.data;
  return CouponReader.id(data);
};
var COUPON_CONFIG = {
  getOptionLabel: getCouponOptionLabel,
  getOptionValue: getCouponOptionValue
};
export default COUPON_CONFIG;